


















import Vue from 'vue';
import {
  Component, Inject, Provide, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  KCardHeader, KCardHeaderBtn,
} from '@kasasa/fbase-components';
import {
  Alert, NoticeClass, AuthStore,
} from '@kasasa/fbase-components/lib';
import JobExecutionsTable from '@/components/jobexecutions/JobExecutionsTable.vue';

@Component({
  computed: mapState([
    'fiId',
  ]),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    JobExecutionsTable,
  },
})
export default class JobExecutions extends Vue {
    headerItems: any = [{
      text: 'Rewards Processing',
      disabled: false,
      link: false,
    },
    {
      text: 'Job Executions',
      disabled: true,
    }];
}
